import React from "react";
import { Provider } from "react-redux";
import AppProvider from "./AppProvider";
import { AuthProvider } from "./contexts/auth";
import { store } from "./redux/store";
import { router } from "./routes";
import { RouterProvider } from "react-router";

const App = () => (
  <Provider store={store}>
    <AppProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </AppProvider>
  </Provider>
);

export default App;
